import { Col, FloatingLabel, FormCheck, FormControl, FormSelect, Row } from "react-bootstrap";
import Validator from "../../../../services/Validator";
import CityAutocomplete from "../../../shared/CityAutocomplete";
import StreetAutocomplete from "../../../shared/StreetAutocomplete";

const AddressMask = ({data, setData, formError, setFormError, setPlaces, hwMode, addressFilled}) => {

    const VALIDATOR = new Validator();

    const x_anlagenverwendungOptions = hwMode ? ["Allgemeine Liegenschaftsteile", "Wohnung", "Gewerbe"]:["Wohnung", "Gewerbe", "Andere"];

    const cityChangeHandler = (newVal) => {
        setFormError({});
        setData(prev => ({
            ...prev,
            city: newVal
        }));
    };

    const streetChangeHandler = (newVal) => {
        setFormError({});
        setData(prev => ({
            ...prev,
            street: newVal
        }));
    }

    return (
        <>
            <p className="text-energo"><b>Anlagenadresse {data.qr_code && "Daten automatisch aus QR-Code ausgefühlt"}</b></p>
            <Row>
                <Col xs="12" md="12" xl="4">
                    <FloatingLabel label="Anlagenverwendung">
                        <FormSelect
                            onChange={e => {setData(prev => ({...prev, x_anlagenverwendung: e.target.value})); setFormError({})}}
                            isValid={data.x_anlagenverwendung}
                            isInvalid={formError.x_anlagenverwendung}
                            value={data.x_anlagenverwendung}
                        >
                            <option value="">Anlagenverwendung auswählen</option>
                            {x_anlagenverwendungOptions.map(o => (
                                <option key={o} value={o}>{o}</option>
                            ))}
                        </FormSelect>
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="12" xl="8" hidden={(hwMode && data.x_anlagenverwendung !== "Allgemeine Liegenschaftsteile") || data.x_anlagenverwendung === ""}>
                    <FloatingLabel label={hwMode? "Spezifische Anlagenverwendung (zb. Liftstrom, Beleuchtung H12, o.Ä.)":"Spezifische Anlagenverwendung"}>
                        <FormControl
                            placeholder="Spezifische Anlagenverwendung"
                            value={data.x_anlagenverwendung_detail}
                            onChange={e => {setData(prev => ({...prev, x_anlagenverwendung_detail: e.target.value})); setFormError({})}}
                            isValid={data.x_anlagenverwendung_detail}
                            isInvalid={formError.x_anlagenverwendung_detail}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="12" xl="4" hidden={!hwMode || data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile" || data.x_anlagenverwendung === ""}>
                    <FloatingLabel label="Bestandseinheitennummer">
                        <FormControl
                            placeholder="Bestandseinheitennummer"
                            value={data.bestand}
                            onChange={e => {setData(prev => ({...prev, bestand: e.target.value})); setFormError({})}}
                            isValid={data.bestand && data.bestand.length > 0}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="6" xl="6">
                    <FloatingLabel label="Land">
                        <FormSelect
                            disabled={addressFilled}
                            value={data.country_id}
                            onChange={e => {setData(prev => ({...prev, country_id: e.target.value})); setFormError({})}}
                            isValid={data.country_id}
                            isInvalid={formError.country_id}
                        >
                            <option value="">Land auswählen</option>
                            <option value="12">Österreich</option>
                            <option value="57">Deutschland</option>
                        </FormSelect>
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="6" xl="6" hidden={data.country_id === undefined || data.country_id !== "12"}>
                    <FloatingLabel label="Bundesland">
                        <FormSelect
                            disabled={addressFilled}
                            value={data.state_id}
                            onChange={e => {setData(prev => ({...prev, state_id: e.target.value})); setFormError({})}}
                            isValid={data.country_id === "12" && data.state_id !== undefined && data.state_id !== ""}
                            isInvalid={formError.state_id}
                        >
                            <option value=""></option>
                            <option value="">Bundesland auswählen</option>
                            <option value="1436">Burgenland</option>
                            <option value="1437">Kärnten</option>
                            <option value="1438">Niederösterreich</option>
                            <option value="1439">Oberösterreich</option>
                            <option value="1440">Salzburg</option>
                            <option value="1441">Steiermark</option>
                            <option value="1442">Tirol</option>
                            <option value="1443">Vorarlberg</option>
                            <option value="1444">Wien</option>
                        </FormSelect>
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="4" xl="4">
                    <FloatingLabel label="PLZ">
                        <FormControl
                            disabled={addressFilled}
                            type="text"
                            placeholder="PLZ"
                            value={data.zip && data.zip}
                            onChange={e => {setData(prev => ({...prev, zip: e.target.value})); setFormError({})}}
                            isValid={VALIDATOR.isValidZip(data.country_id, data.state_id, data.zip)}
                            isInvalid={formError.zip}
                            maxLength={data.country_id === "12"? 4:5}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="8" xl="8">
                    <CityAutocomplete
                        disabled={addressFilled}
                        zip={data.zip}
                        country={data.country_id}
                        city={data.city}
                        setCity={cityChangeHandler}
                        outsidePlaces={setPlaces}
                        isError={formError.city? true:false}
                    />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="12" xl="8">
                    <StreetAutocomplete
                        disabled={addressFilled}
                        country={data.country_id}
                        zip={data.zip}
                        city={data.city}
                        street={data.street}
                        setStreet={streetChangeHandler}
                        isError={formError.street? true:false}
                    />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="8" md="4" xl="4">
                    <FloatingLabel label="Hausnummer">
                        <FormControl
                            disabled={addressFilled}
                            type="text"
                            placeholder="Hausnummer"
                            value={data.houseNr}
                            onChange={e => {setData(prev => ({...prev, houseNr: e.target.value})); setFormError({})}}
                            isValid={data.houseNr && data.houseNr !== ""}
                            isInvalid={formError.houseNr}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="8" md="4" xl="4" hidden={data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile" || data.x_anlagenverwendung === ""}>
                    <FloatingLabel label="Stiege">
                        <FormControl
                            type="text"
                            placeholder="Stiege"
                            value={data.stiege}
                            onChange={e => {setData(prev => ({...prev, stiege: e.target.value})); setFormError({})}}
                            isValid={data.stiege && data.stiege !== ""}
                            isInvalid={formError.stiege}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="8" md="4" xl="4" hidden={data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile" || data.x_anlagenverwendung === ""}>
                    <FloatingLabel label="Top">
                        <FormControl
                            type="text"
                            placeholder="Top"
                            value={data.top}
                            onChange={e => {setData(prev => ({...prev, top: e.target.value})); setFormError({})}}
                            isValid={data.top && data.top !== ""}
                            isInvalid={formError.top}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            {hwMode &&
                <Row className="mt-3" hidden={data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile" || data.x_anlagenverwendung === ""}>
                    <Col>
                        <FormCheck
                            type="checkbox"
                            label="Als Leerstand anmelden"
                            checked={data.leerstand}
                            onChange={e => {setData(prev => ({...prev, leerstand: e.target.checked})); setFormError({})}}
                        />
                    </Col>
                </Row>
            }
        </>
    )
}
export default AddressMask;